import React, { useMemo, useRef, useState } from "react";
import { Button, Popover, PopoverBody } from "reactstrap";
import { DynamicGroup } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/ResultingListForm/Addons/DynamicGroup";
import { Icon } from "components/Icon/Icon";
import type { Section } from "components/_ProductConfigurator/store/ProductConfiguration.types";
import { buildTitle } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/ResultingListForm/Addons/AddonsHelpers";
import { useResultingListForm } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/providers/ResultingListFormContextProvider";

type AddonProps = {
  addonItem: Section;
};

export const Addon = ({ addonItem }: AddonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { values } = useResultingListForm();

  const titleWithValues = useMemo(() => {
    return buildTitle({ section: addonItem, values });
  }, [values, addonItem]);

  const [open, setOpen] = useState(false);

  return (
    <div className="position-relative w-100 mt-3">
      <span
        className="position-absolute fs-md fw-bold"
        style={{ top: "-1.25rem" }}
      >
        {addonItem.title}
      </span>

      <Button
        innerRef={buttonRef}
        className="w-100 border-gray-300 d-flex align-items-center justify-content-between px-2"
        color="transparent"
        outline
      >
        {titleWithValues}
        <Icon
          iconName={open ? "chevron-up-regular" : "chevron-down-regular"}
          prefix="trox"
          className="border-start ps-2"
        />
      </Button>
      <Popover
        isOpen={open}
        target={buttonRef as React.RefObject<HTMLElement>}
        toggle={() => setOpen((o) => !o)}
        placement="bottom-start"
        trigger="legacy"
        modifiers={[
          {
            name: "sameWidth",
            enabled: true,
            phase: "beforeWrite",
            requires: ["computeStyles"],
            fn: ({ state }) => {
              state.styles.popper.width = `${state.rects.reference.width > 350 ? state.rects.reference.width : 350}px`;
            },
          },
        ]}
      >
        <PopoverBody className="w-100">
          {addonItem.groups.length > 0 && (
            <>
              <DynamicGroup group={addonItem.groups[0]} groupIndex={0} />

              {addonItem.groups.length > 1 && (
                <div className="border mt-3 p-3 rounded">
                  <DynamicGroup group={addonItem.groups[1]} groupIndex={1} />

                  {addonItem.groups.length > 2 && (
                    <div
                      className="d-grid mt-3 border-top pt-3"
                      style={{
                        gridTemplateColumns: "1fr 1fr",
                        gap: "12px",
                      }}
                    >
                      {addonItem.groups.slice(2).map((group, index) => (
                        <DynamicGroup
                          key={index + 2}
                          group={group}
                          groupIndex={index + 2}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </PopoverBody>
      </Popover>
    </div>
  );
};
